/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */

export const AUTH_COPY = {
  ar: {
    docTitle: "مدار — انضم إلى مدار",
    modeSignup: "إنشاء حساب جديد",
    modeLogin: "تسجيل الدخول",
    suTitle: "أنشئ متجرك الآن",
    suSub: "كل شي بصفحة واحدة — ادخل المعلومات وراح يكون متجرك جاهز.",
    nameL: "اسمك الكامل",
    nameP: "مثال: مجتبى أحمد",
    nameE: "رجاءً اكتب اسمك",
    storeL: "اسم المتجر",
    storeP: "مثال: متجر النور",
    storeH: "الاسم الظاهر لزبائنك — ولا علاقة له برابط المتجر",
    storeE: "اسم المتجر يجب أن يكون 3 أحرف على الأقل",
    phoneL: "رقم الهاتف",
    phoneH: 'اكتب الرقم بدون الصفر (0) بالبداية — مثال: <span class="madar-auth-ltr">770 123 4567</span>',
    phoneE: "اكتب رقم هاتف عراقي صحيح يبدأ بـ 7 بدون صفر بالبداية",
    emailL: "البريد الإلكتروني",
    emailE: "اكتب بريداً إلكترونياً صحيحاً",
    userL: "يوزر المتجر",
    userTag: "(معرف المتجر)",
    userH: 'هذا المعرف هو اللي يحدد رابط متجرك على الإنترنت — اكتبه بأحرف إنجليزية صغيرة وأرقام و "-" فقط (3–30 حرفاً). مثال: تكتب <span class="madar-auth-ltr">alnoor-store</span> فيصير رابط متجرك <span class="madar-auth-ltr">alnoor-store.madar.iq</span>',
    userE: "المعرف يجب أن يكون 3 أحرف على الأقل (أحرف إنجليزية صغيرة، أرقام، أو -)",
    lbLabel: "رابط متجرك راح يكون:",
    lbOk: "متاح",
    passL: "كلمة المرور",
    passP: "اكتب كلمة مرور قوية",
    pwLen: "٨ أحرف على الأقل",
    pwCase: "حرف كبير وحرف صغير (A و a)",
    pwNum: "رقم واحد على الأقل (0-9)",
    pwSym: "رمز خاص (! @ # $)",
    passE: "كلمة المرور لازم تحقق كل الشروط المذكورة",
    pass2L: "تأكيد كلمة المرور",
    pass2P: "أعد كتابة كلمة المرور",
    pass2E: "كلمتا المرور غير متطابقتين",
    suCta: "أنشئ متجرك مجاناً",
    suLoading: "جارٍ إنشاء المتجر...",
    termsA: "بإنشاء الحساب أنت توافق على",
    termsB: "شروط الاستخدام",
    termsC: "و",
    termsD: "سياسة الخصوصية",
    liTitle: "أهلاً بعودتك",
    liSub: "ادخل رقم هاتفك أو بريدك الإلكتروني مع كلمة المرور للوصول إلى لوحة تحكم متجرك.",
    tabPhone: "رقم الهاتف",
    tabEmail: "البريد الإلكتروني",
    passPLi: "كلمة المرور",
    passELi: "اكتب كلمة المرور",
    forgot: "نسيت كلمة المرور؟",
    noAcc: "ليس لديك حساب؟",
    goSignup: "إنشاء حساب جديد",
    liCta: "تسجيل الدخول",
    liLoading: "جارٍ تسجيل الدخول...",
    langBtn: "English",
    formFix: "تحقق من الحقول",
    networkErr: "فشل الاتصال بالخادم",
    accountExists:
      "هذا البريد مسجّل مسبقاً. سجّل الدخول بنفس كلمة السر لمتابعة متجرك.",
    created: "تم إنشاء الحساب بنجاح",
    loggedIn: "تم تسجيل الدخول بنجاح",
    trialWelcome: "تم الدخول بالاشتراك التجريبي",
    slugTaken: "معرف المتجر مستخدم مسبقاً، يرجى اختيار معرف آخر",
  },
  en: {
    docTitle: "Madar — Join Madar",
    modeSignup: "Create new account",
    modeLogin: "Sign in",
    suTitle: "Create your store now",
    suSub: "Everything on one page — enter your details and your store is ready.",
    nameL: "Full name",
    nameP: "e.g. Mujtaba Ahmed",
    nameE: "Please enter your name",
    storeL: "Store name",
    storeP: "e.g. Alnoor Store",
    storeH: "The name your customers see — separate from your store link",
    storeE: "Store name must be at least 3 characters",
    phoneL: "Phone number",
    phoneH: 'Enter the number without the leading zero (0) — e.g. <span class="madar-auth-ltr">770 123 4567</span>',
    emailL: "Email address",
    emailE: "Enter a valid email address",
    phoneE: "Enter a valid Iraqi number starting with 7, without a leading zero",
    userL: "Store username",
    userTag: "(store ID)",
    userH: 'This ID defines your store link on the internet — lowercase English letters, numbers and "-" only (3–30 characters). Example: type alnoor-store and your store link becomes alnoor-store.madar.iq',
    userE: "The ID must be at least 3 characters (lowercase letters, numbers or -)",
    lbLabel: "Your store link will be:",
    lbOk: "Available",
    passL: "Password",
    passP: "Choose a strong password",
    pwLen: "At least 8 characters",
    pwCase: "Upper & lowercase letters (A and a)",
    pwNum: "At least one number (0-9)",
    pwSym: "A special character (! @ # $)",
    passE: "Your password must meet all the requirements above",
    pass2L: "Confirm password",
    pass2P: "Re-type your password",
    pass2E: "The two passwords don't match",
    suCta: "Create your store for free",
    suLoading: "Creating your store...",
    termsA: "By creating an account you agree to our",
    termsB: "Terms of Service",
    termsC: "&",
    termsD: "Privacy Policy",
    liTitle: "Welcome back",
    liSub: "Enter your phone number or email and your password to reach your store dashboard.",
    tabPhone: "Phone number",
    tabEmail: "Email",
    passPLi: "Your password",
    passELi: "Please enter your password",
    forgot: "Forgot password?",
    noAcc: "Don't have an account?",
    goSignup: "Create new account",
    liCta: "Sign in",
    liLoading: "Signing in...",
    langBtn: "عربي",
    formFix: "Please fix the form",
    networkErr: "Network error",
    accountExists:
      "This email is already registered. Sign in with the same password to continue.",
    created: "Account created successfully",
    loggedIn: "Login successful",
    trialWelcome: "You signed in with the trial subscription",
    slugTaken: "This store ID is already taken, please choose another one",
  },
};

export const USER_HANDLE_RE = /^[a-z0-9](?:[a-z0-9-]{1,28}[a-z0-9])?$/;

export const PASSWORD_RULES = {
  len: (v) => v.length >= 8,
  case: (v) => /[A-Z]/.test(v) && /[a-z]/.test(v),
  num: (v) => /\d/.test(v),
  sym: (v) => /[!@#$%^&*()_\-+=[\]{};:'",.<>/?\\|~`]/.test(v),
};

export function formatIraqiPhone(raw) {
  let v = String(raw || "").replace(/\D/g, "");
  if (v.startsWith("964")) v = v.slice(3);
  if (v.startsWith("0")) v = v.slice(1);
  v = v.slice(0, 10);
  if (v.length > 6) return `${v.slice(0, 3)} ${v.slice(3, 6)} ${v.slice(6)}`;
  if (v.length > 3) return `${v.slice(0, 3)} ${v.slice(3)}`;
  return v;
}

export function digitsOnlyPhone(raw) {
  let v = String(raw || "").replace(/\D/g, "");
  if (v.startsWith("964")) v = v.slice(3);
  if (v.startsWith("0")) v = v.slice(1);
  return v.slice(0, 10);
}

export function isValidIraqiPhone(raw) {
  const ph = digitsOnlyPhone(raw);
  return ph.length === 10 && ph.startsWith("7");
}

export function cleanStoreHandle(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-")
    .slice(0, 30);
}

export function isValidStoreHandle(value) {
  return USER_HANDLE_RE.test(value) && value.length >= 3;
}

export function passwordMeetsAllRules(value) {
  return Object.values(PASSWORD_RULES).every((fn) => fn(value));
}
